import React from 'react';
import { makeStyles } from '@material-ui/core';
import logo from "../img/logo.png";
import mission from "../img/mission_bg.png";
import missionIcon1 from "../img/mission_icon01.png";
import missionIcon2 from "../img/mission_icon02.png";
import missionIcon3 from "../img/mission_icon03.png";
import biLogo from "../img/bi_logo.png";
import appguide from "../img/appguide_img.png";
import appstore from "../img/appstore_btn.png";
import googleplay from "../img/googleplay_btn.png";
import instalogo from "../img/appguide_instalogo.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const useStyles = makeStyles(theme => ({

    aboutStyle: {
        textAlign: "center",
        padding: "120px 0px 100px"

    },
    missionStyle: {

        backgroundImage: `url(${mission})`,
        //  width: "100%",

        padding: "130px 0px 105px",
        // display: 'flex',
        backgroundRepeat: 'no-repeat',
        textAlign: "center",
        backgroundSize: "cover"

    },
    missonBlock: {
        display: "inline-block", width: "265px"
    },

    mission: {

        backgroundRepeat: 'no-repeat',
        border: "2px solid #fff",
        borderRadius: "100%",
        width: "auto",
        // height: "265px",
        height: "auto",
        //display: "flex",

    },

    visionStyle: {
        backgroundColor: "#fff",
        textAlign: "center",
        padding: "130px 0px 105px",
    },
    brandStyle: {
        padding: "130px 0px 105px",
        textAlign: "center",
    },
    instagramStyle: {
        backgroundColor: "#fff",
        textAlign: "center",
        padding: "130px 0px 105px",
    },
    appguideStyle: {
        textAlign: "center",
        padding: "130px 0px 105px",

    },
    imgStyle: {
        display: "flex",
        textAlign: "center",
        justifyContent: "center",
        "@media (max-width: 770px)": {
            display: "inline",
        }

    },
    appguideimgStyle: {
        "@media (max-width: 770px)": {
            width: "50%",
        }

    },
    writeStyle1: {
        color: theme.palette.primary.main,
        fontSize: "50px",
        fontFamily: "Roboto"
    },
    writeStyle2: {
        lineHeight: "35px",
        fontSize: "18px",
        color: "#333333",
        margin: "0px 0px 100px 0px"
        // fontFamily: "Noto Sans KR",
    },
    writeStyle3: {
        color: '#f3f3f3',
    },
    writeStyle4: {
        fontSize: "22px",
        lineHeight: "30px",
        "@media(max-width:770px)": {
            fontSize: "15px",
            lineHeight: "20px",

        }
    },
    writeStyle5: {
        fontWeight: 'bold',
        fontSize: '25px',
        padding: "0px 0px 100px 0px"
    },
    writeStyle6: {
        fontFamily: "Noto Sans KR",
        fontSize: "40px",
        lineHeight: "55px",
        fontWeight: "bold",

        // margin: "60px 0px 55px"
    },
    writeStyle7: {
        fontFamily: "Noto Sans KR",
        fontSize: "40px",
        lineHeight: "55px",
        fontWeight: "bold",
        color: theme.palette.primary.main,
        margin: "0px 0px 100px 0px"
    },
    writeStyle8: {

        fontWeight: 'bold',
        fontSize: '25px',
        padding: "50px 0px 50px 0px"

    },



}))



const About = () => {

    const style = useStyles();


    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };



    return (
        <>
            <div className={style.aboutStyle}>
                <h1>ABOUT US</h1>
                <h2 style={{ fontSize: "45px", fontWeight: '500' }}>대학생 설문조사 품앗이 플랫폼</h2>
                <h3 className={style.writeStyle1}>Lifestyle Needs Solution.</h3>
                <p className={style.writeStyle2}>
                    Survey는 빠르게 변화하는 미디어 환경 속에서 끊임없이 진화합니다. <br />
                    문제를 해결하고자 하는 작은 아이디어를 바탕으로 더욱 정교하고 견고하게 <br />
                    더 많은 사람과 연결되어, 삶의 문제를 해결합니다. <br />
                    빠른 시도와 실패의 가치를 소중히 여기고 함께 성장하는 것, <br />
                    Survey가 한발 앞서 시장을 선도할 수 있는 이유입니다.
                </p>
                <img src={logo} alt="logo" />
            </div>
            <div className={style.missionStyle}>
                <div className={style.writeStyle3}>
                    <h1 >MISSION</h1>
                    <div style={{ fontWeight: 500, fontSize: "35px" }}>연결을 통한 나눔과 성장을 실천합니다.</div>
                </div>
                <div className={style.writeStyle3} style={{ display: "flex", justifyContent: "space-around", marginTop: "50px" }}>
                    <div className={style.missonBlock}>
                        <div className={style.mission} style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ alignSelf: "center" }}>
                                <img src={missionIcon1} alt="연결" />
                                <h2>
                                    연결
                                </h2>
                            </div>
                        </div>
                        <div className={style.writeStyle4}>
                            빠른 솔루션으로 연결<br />
                            감사와 도움을 연결<br />
                            편리하고 효율적인 연결<br />
                        </div>
                    </div>
                    <div className={style.missonBlock}>
                        <div className={style.mission} style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ alignSelf: "center" }}>
                                <img src={missionIcon2} alt="나눔" />
                                <h2>
                                    나눔
                                </h2>
                            </div>
                        </div>
                        <div className={style.writeStyle4}>
                            진심을 채운 행복 나눔<br />
                            창의적인 아이디어 나눔<br />
                            꿈과 마음을 나눔<br />
                        </div>
                    </div>
                    <div className={style.missonBlock}>
                        <div className={style.mission} style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ alignSelf: "center" }}>
                                <img src={missionIcon3} alt="성장" />
                                <h2>
                                    성장
                                </h2>
                            </div>
                        </div>
                        <div className={style.writeStyle4}>
                            어제보다 나은 우리<br />
                            모두의 성공<br />
                            꿈이 현실이 되는 미래<br />
                        </div>
                    </div>



                </div>
            </div>
            <div className={style.visionStyle}>
                <div className={style.writeStyle5}>VISION</div>
                <div className={style.writeStyle6}>세상의 모든 사업자와 고객을 연결하는</div>
                <div className={style.writeStyle7}>최고로 존경받는 행복한 회사</div>
                <div className={style.writeStyle2}>
                    <div>라스트마일 딜리버리(Last Mile Delivery) 시장의 선도 기업으로</div>
                    <div>고품질의 근거리 물류 IT 플랫폼 서비스와 솔루션을 제공하고,</div>
                    <div>다양한 소비자의 니즈를 충족시키기 위한 창의적인 혁신을 추구합니다</div>
                </div>
            </div>
            <div className={style.brandStyle}>
                <div className={style.writeStyle5}>BRAND IDENTITY</div>
                <div className={style.writeStyle2}>
                    <div>Survey의 로고는 ‘세상의 모든 사업자와 고객을 연결한다’라는 바로고의 미션, 철학을</div>
                    <div>바탕으로 사업자와 고객을 지도 위의 맵핀으로 표현하고 Survey가 그 사이에서</div>
                    <div>지속적으로 유기적인 연결고리 역할을 하는 모습을 형상화하여 ‘연결의 무한한 가능성’을 나타냅니다</div>

                </div>
                <img src={biLogo} alt="bi_logo" />
            </div>

            <div className={style.instagramStyle}>
                <div className={style.writeStyle5}>instagram</div>
                <div>@surbay_official</div>
                <Carousel responsive={responsive}>
                    <img src={biLogo} alt="bi_logo" />
                    <img src={appguide} alt="app_guide" width="30%" />
                    <img src={biLogo} alt="bi_logo" />
                    <img src={appguide} alt="app_guide" width="30%" />
                    <img src={biLogo} alt="bi_logo" />
                    <img src={appguide} alt="app_guide" width="30%" />
                    <img src={biLogo} alt="bi_logo" />
                    <img src={appguide} alt="app_guide" width="30%" />
                </Carousel>
            </div>
            <div className={style.appguideStyle}>
                <div className={style.writeStyle8}>
                    APP GUIDE
                </div>
                <div className={style.imgStyle}>

                    <img className={style.appguideimgStyle} src={appguide} alt="app_guide" />

                    <div >
                        <div>
                            <div className={style.writeStyle8}>어플 다운로드</div>
                            <img src={appstore} className={style.appguideimgStyle} alt="appstore" /><span> </span>
                            <img src={googleplay} className={style.appguideimgStyle} alt="googleplay" />
                        </div>
                        <br />
                        <br />
                        <div>
                            <div className={style.writeStyle8}>인스타그램</div>
                            <img src={instalogo} alt="instalogo" />
                            @surbay_official

                        </div>
                    </div>
                </div>

            </div>

        </>
    )

}



export default About;